<template>
  <b-container
    fluid
    class="bg-white shadow-inset-top"
    style="min-height: calc(100vh - 95px); max-height: calc(100vh - 95px); overflow-y: auto"
    data-cy="reschedule-main-container"
  >
    <b-row style="height: 100%" data-cy="reschedule-main-row">
      <b-col cols="12" data-cy="reschedule-content-col">
        <b-container class="p-4 p-md-5" data-cy="reschedule-content-container">
          <b-row data-cy="reschedule-header-row">
            <b-col cols="12" class="mb-5" data-cy="reschedule-header-col">
              <h4
                class="text-primary font-weight-bold"
                data-cy="reschedule-title"
              >
                Data e Hora
              </h4>
              <small class="font-weight-bold" data-cy="reschedule-subtitle">
                Selecione a
                <strong data-cy="reschedule-subtitle-bold">nova</strong>
                data e hora de sua preferência
              </small>
            </b-col>
          </b-row>

          <b-row data-cy="reschedule-schedules-row">
            <b-col
              cols="12"
              class="text-center"
              v-if="loading"
              data-cy="reschedule-loading-col"
            >
              <b-spinner
                variant="info"
                class="mt-3"
                label="Spinning"
                center
                data-cy="reschedule-loading-spinner"
              ></b-spinner>
            </b-col>
            <b-col data-cy="reschedule-schedules-list-col">
              <agenda-geral-main
                v-for="agenda in schedules"
                :key="agenda.id"
                reschedule="true"
                :schedule="agenda"
                :data-cy="`reschedule-agenda-item-${agenda.id}`"
              ></agenda-geral-main>
            </b-col>
          </b-row>

          <b-row v-if="!loading" data-cy="reschedule-actions-row">
            <b-col class="bg-white" data-cy="reschedule-actions-col">
              <hr class="w-100 my-5" data-cy="reschedule-actions-hr" />
              <div
                id="workflow-buttons-wrapper"
                class="d-flex justify-content-between"
                data-cy="reschedule-actions-btn-wrapper"
              >
                <router-link
                  :to="{
                    name: 'history',
                    params: { organizationId: $route.params.organizationId }
                  }"
                  class="btn btn-outline-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0"
                  data-cy="reschedule-btn-voltar"
                  >Voltar e Ajustar</router-link
                >

                <a
                  href="#"
                  @click="confirm"
                  :class="
                    `${
                      !horario ? 'disabled' : ''
                    } btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0`
                  "
                  data-cy="reschedule-btn-confirmar"
                  >Confirmação</a
                >
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Carousel from "vue-owl-carousel";
import ScheduleTabDateItem from "@/components/scheduletabdateitem.vue";
import AgendaGeralMain from "@/components/agenda-geral-main.vue";
import { axiosInstance as Axios } from "@/main";

export default {
  name: "reschedule",
  data() {
    return {
      schedules: [],
      loading: true,
      loadMore: false,
      owl: null,
      visualized: 0,
      loadLess: true,
      onePage: 0
    };
  },
  methods: {
    async confirm() {
      if (!this.horario) {
        return;
      }

      try {
        let response = await Axios.patch(
          `${this.$serverHost}protected/me/agendamentos/${this.reschedule.id}/reagendar`,
          {
            agendaId: this.$store.getters.get_selected[3].medics[0].agendaId,
            horaAgendamento: this.$store.getters.get_selected[3].date
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`
            }
          }
        );

        console.log(response.data.id);
        this.$router.push({
          name: "history",
          params: { organizationId: this.$route.params.organizationId }
        });
      } catch (e) {
        console.log(e);
      }
    }
  },
  components: {
    Carousel,
    ScheduleTabDateItem,
    AgendaGeralMain
  },
  computed: {
    horario() {
      return this.$store.getters.get_selected[3].nome;
    },
    reschedule() {
      return this.$store.getters.reschedule;
    }
  },
  async mounted() {
    if (!this.reschedule) {
      this.$router.push({
        name: "history",
        params: { organizationId: this.$route.params.organizationId }
      });
      return;
    }

    try {
      let response = await Axios.get(
        `${this.$serverHost}protected/me/agendamentos/${this.reschedule.id}/agendas`,
        {
          headers: {
            "X-Organizacao-ID": this.$route.params.organizationId,
            Authorization: `Bearer ${this.$store.getters.token}`
          }
        }
      );

      this.onePage = this.visualized;
      this.schedules = response.data;
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }
};
</script>

<style></style>
